import ManagerTax from './ManagerTax';

export default ManagerTax;
